import React, { useEffect, useMemo, useState } from 'react';


const MESSAGES = [
  "Vous avez des acouphènes ?\nHearen est là pour ça."
];

const LAST_INTRO_DATE_KEY = 'HEAREN_LAST_INTRO_DATE';
const LAST_INTRO_MESSAGE_KEY = 'HEAREN_LAST_INTRO_MESSAGE';

export const shouldShowHearenIntro = () => {
  if (typeof window === 'undefined') return false;

  const publicAuthPaths = [
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
  ];

  if (publicAuthPaths.includes(window.location.pathname)) {
    return false;
  }

  return true;
};

const pickMessage = () => {
  const lastMessage = localStorage.getItem(LAST_INTRO_MESSAGE_KEY);

  const available = MESSAGES.filter((msg) => msg !== lastMessage);
  const pool = available.length > 0 ? available : MESSAGES;

  const message = pool[Math.floor(Math.random() * pool.length)];
  localStorage.setItem(LAST_INTRO_MESSAGE_KEY, message);

  return message;
};

export default function HearenIntroIdentity({ onComplete }) {
  
  const appLanguage =
  localStorage.getItem('hearen_lang') || 'fr';

  const isFrench = appLanguage.startsWith('fr');
  const message = useMemo(() => pickMessage(), []);
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [showSecondLine, setShowSecondLine] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setVisible(true);
    }, 250);

    const secondLineTimer = setTimeout(() => {
      setShowSecondLine(true);
    }, 1400);

    const leaveTimer = setTimeout(() => {
      setLeaving(true);
    }, 4600);

    const completeTimer = setTimeout(() => {
      onComplete?.();
    }, 5600);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(secondLineTimer);
      clearTimeout(leaveTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`
        fixed inset-0 z-[9999] flex flex-col items-center justify-center
        bg-[#070A0F] text-white overflow-hidden
        transition-opacity duration-1000
        ${leaving ? 'opacity-0' : 'opacity-100'}
      `}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(120,160,255,0.18),transparent_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,rgba(80,220,190,0.10),transparent_60%)]" />

      <div
        className={`
          relative z-10 flex flex-col items-center px-8 text-center
          transition-all duration-1000
          ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}
        `}
      >
        <div className="mb-8 flex items-center justify-center">
          <img
            src="/hearen-logo.png"
            alt="Hearen"
            className="w-52 object-contain opacity-95"
          />
        </div>

        <p className="text-[22px] leading-relaxed font-light tracking-[-0.02em] text-white/92">
          {isFrench
            ? 'Vous avez des acouphènes ?'
            : 'Do you have tinnitus?'}
        </p>

          <p
           className={`
             mt-2 text-[22px] leading-relaxed font-light tracking-[-0.02em] text-white/92
             transition-all duration-[3200ms] delay-[1800ms] ease-out
            ${showSecondLine ? 'opacity-100 translate-y-0 blur-0' : 'opacity-0 translate-y-1 blur-[2px]'}
            `}
          >
           {isFrench
             ? 'Hearen est là pour ça.'
             : 'Hearen is here for that.'}
          </p>
              </div>
            </div>
          );
        }